import "slick-carousel";

$('.testimonials-slider').slick({
  infinite: true,
  arrows: true,
  speed: 300,
  prevArrow: $('.testimonials-prev'),
  nextArrow: $('.testimonials-next'),
  slidesToShow: 2,
  slidesToScroll: 1,
  touchThreshold: 100,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      }
    }
  ]
});


$(document).ready(function () {

  $('.expand-button').on('click', function () {
    var $specialText = $(this).parent().siblings('.special-text');
    $specialText.toggleClass('-expanded');

    if ($specialText.hasClass('-expanded')) {
      $(this).html('Read Less');
    } else {
      $(this).html('Read more');
    }
  });



});